/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Modal, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import UserCampaignDetails from "../CampaignManagement/CampaignDetailsPage/UserCampaignDetails";
import { CurrentCampaignDetails } from "../../redux/actions/campaignAction";
import { GetRequestCallAPI } from "../../Api/GetRequest";
import { ADMIN_CAMPAIGN_GET } from "../Shared/constant";
import Spinner from "react-bootstrap/Spinner";

const PreviewImage = ({
  closePopup,
  selectedImage,
  selectedData,
  bothData,
}) => {
  const { accessToken } = useSelector((state) => state.personalReducers);
  const { CurrentCampaignGet } = useSelector((state) => state.campaignReducers);
  const [loading, setLoading] = useState(false);
  //  const   url  =  process.env.REACT_APP_BASE_URL_CREATING_COMPAIGN_URL
  const dispatch = useDispatch();
  // const iframeSrc = `${url}campaigns/${selectedData?.id}?donation=false&access_token=${accessToken}`;
  // console.log("url",url)
  // console.log("iframeSrc",iframeSrc)

  const ApiCall = async () => {
    setLoading(true);
    const response = await GetRequestCallAPI(
      `${ADMIN_CAMPAIGN_GET}/${selectedData?.id}`,
      accessToken
    );
    if (response?.status === 200) {
      dispatch(CurrentCampaignDetails({ ...response?.data?.data }));
      setLoading(false);
    } else {
      dispatch(CurrentCampaignDetails({}));
      setLoading(false);
    }
  };

  useEffect(() => {
    // console.log("selectedData?.id",selectedData?.id)
    ApiCall();
  }, [selectedData?.id]);

  return (
    <>
      <Modal
        centered
        className={`modal-preview ${
          !selectedData?.slug && !bothData?.id ? "modal-preview-new" : ""
        } `}
        show={true}
        onHide={closePopup}
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <button
          type="button"
          className="btn-close"
          aria-label="Close"
          onClick={closePopup}
        ></button>
        <Modal.Body>
          {selectedImage && (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100%",
                marginBottom: "20px",
              }}
            >
              {selectedImage && (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "100%",
                    width: "100%",
                  }}
                >
                  <img
                    src={selectedImage}
                    alt="Selected Avatar"
                    style={{
                      maxWidth: "100%",
                      maxHeight: "100%",
                      objectFit: "contain",
                    }}
                  />
                </div>
              )}
            </div>
          )}
          {selectedData && (
            <div style={{display: "flex",justifyContent: "center", alignItems: "center",height: "100%",width: "100%"}}>
              {loading ? (
                <div className="loader_Background">
                  <Spinner animation="border" role="status" />
                  <h4>Please Wait...</h4>
                </div>
              ) : (
                <div style={{overflowY: "auto",height:"95%",background:"#EFEEEC",width:"100%"}}>
                <UserCampaignDetails previewPart={true} campaignDetails={CurrentCampaignGet} />
                </div>
                  
              )}
            </div>
          )}
          {bothData && (
            <Row className="m-0">
              <div className={`col-6`}>
                <h5>Source Image</h5>
                <img
                  src={bothData?.source_image?.view_file_url}
                  alt={bothData?.source_image?.view_file_url}
                  className="image-preview w-100"
                  style={{ objectFit: "contain", height: "70%" }}
                />
                <a
                  href={bothData.source_image.view_file_url}
                  style={{ margin: "10px" }}
                  className="btn btn-primary cmnfilterHeadbtn"
                >
                  Download Source Image
                </a>
              </div>
              {bothData?.mosaic_image?.view_file_url ? (
                <div className={`col-6`}>
                  <h5>Mosaic Image</h5>
                  <img
                    src={bothData?.mosaic_image?.view_file_url}
                    alt={bothData?.mosaic_image?.view_file_url}
                    className="image-preview w-100"
                    style={{ objectFit: "contain", height: "70%" }}
                  />
                  <a
                    href={bothData.mosaic_image.view_file_url}
                    download
                    style={{ margin: "10px" }}
                    className="btn btn-primary cmnfilterHeadbtn"
                  >
                    Download Mosaic Image
                  </a>
                </div>
              ) : (
                <div className="col-6">
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      height: "70%",
                      justifyContent: "center",
                      border: "1px solid gray",
                      borderRadius: "10px",
                      padding: "10px",
                      margin: "10px",
                    }}
                  >
                    <p
                      style={{
                        textAlign: "center",
                        marginBottom: "0px",
                      }}
                    >
                      No Mosaic Image Found
                    </p>
                  </div>
                </div>
              )}
            </Row>
          )}
        </Modal.Body>
      </Modal>
    </>
  );
};

export default PreviewImage;
